/* eslint-disable no-unused-vars */
import React from 'react'
import DynamicServiceLayout from './DynamicServiceLayout'
import { FaArrowRight } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// import { FaCheckCircle } from 'react-icons/fa'

// eslint-disable-next-line react/prop-types
const ServiceDetailsArea = ({ content, images, title, layout }) => {
  const { t } = useTranslation()
  const services = t('services-slider', { returnObjects: true })

  return (
    <div className="container pd-bottom-120 pd-top-120">
      <div className="row">
        <div className="col-lg-4">
          <div className="td-sidebar service-sidebar">
            <div className="widget widget_catagory">
              <h5 className="widget-title">
                <FaArrowRight />
                {t('all-service-list')}
              </h5>
              <ul className="catagory-items">
                {services.map((service) => (
                  <li key={service.id}>
                    <Link to={`/service/${service.id}`}>{service.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="widget widget_author text-center">
              <div className="thumb">
                <img src="assets/img/about/9.png" alt="img" />
              </div>
              <div className="details">
                <Link className="btn btn-base border-radius-5" to="/">
                  Discover our company +
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-8">
          <DynamicServiceLayout
            title={title}
            content={content}
            images={images}
            layout={layout}
          />
        </div>
      </div>
    </div>
  )
}

export default ServiceDetailsArea
